/* This file should contain any constants shared across multiple components */
export const CUSTOM_PROPERTY_COLUMN_PREFIX = 'properties.custom.';
export const PROFILER_COLUMN_NAME = 'profile_data.ntiles';

export const NEW_CUSTOM_PROPERTY_COLUMN_PREFIX = 'properties2';

export const EMAIL_REGEX = /^[a-zA-Z0-9_.+'+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
